import { createContext, useContext, useState, useCallback, useEffect, useRef } from "react";
import { getNotificationsCount } from "@api/notification";

export const NotificationCountContext = createContext();

export const useNotificationCount = () => {
  const context = useContext(NotificationCountContext);
  if (!context) {
    throw new Error(
      "useNotificationCount must be used within NotificationCountProvider"
    );
  }
  return context;
};

export const NotificationCountProvider = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const hasInitialized = useRef(false);

  // Fetch unread count from API
  const getCount = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await getNotificationsCount();
      
      // Handle the response - it should contain unread_count
      const count = response?.unread_count || 0;
      setUnreadCount(count);
      
      return count;
    } catch (error) {
      console.error("Error fetching notification count:", error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Auto-initialize on first mount
  useEffect(() => {
    if (!hasInitialized.current) {
      hasInitialized.current = true;
      getCount();
    }
  }, [getCount]);

  const value = {
    unreadCount,
    setUnreadCount,
    getCount,
    isCountLoading:isLoading,
  };

  return (
    <NotificationCountContext.Provider value={value}>
      {children}
    </NotificationCountContext.Provider>
  );
};
